module.exports = __webpack_public_path__ + "img/img-shop-food-0.04fa5385.png";